
export default {
  name: "CheckboxSwitch",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", !this.value);
    }
  },
  computed: {
    switchClass() {
      return {
        disabled: this.disabled,
        checked: this.value
      };
    }
  }
};
